export const setUSERINTERFACEOBJECT = "setUSERINTERFACEOBJECT";
